import { InjectionToken } from '@angular/core';

export const BROWSER_LANGUAGE_TOKEN = new InjectionToken<string>('BROWSER_LANGUAGE_TOKEN');
